export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fmtWhen = (s) => {
  if (!s) return "";
  const d = new Date(s);
  const g = d.toLocaleString("ar-SA-u-nu-latn-ca-gregory", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });
  return `${g} · ${hijriOf(d)}`;
};
export const hijriOf = (d) => new Intl.DateTimeFormat("ar-SA-u-ca-islamic-umalqura-nu-latn", { day: "numeric", month: "long", year: "numeric" }).format(d);
export const fmtTime = (s) => (s ? s.slice(11, 16) : "");
export const MEET_COLORS = {
  blue: "bg-blue-500", emerald: "bg-emerald-500", amber: "bg-amber-500", rose: "bg-rose-500", violet: "bg-violet-500", slate: "bg-slate-500",
};
export const STATUS = { scheduled: ["مجدول", "bg-blue-50 text-blue-700"], done: ["منتهي", "bg-emerald-50 text-emerald-700"], cancelled: ["ملغي", "bg-slate-100 text-slate-500"] };
export const nowLocal = () => { const d = new Date(); return `${ymd(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`; };
